var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('map-radius',{attrs:{"list":_vm.locationList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }